import React from "react";

import Explore from "../imgs/explore/card2.png";
import Table from "../imgs/table.png";

const Goal = () => {
  return (
    <section className="space-y-4 md:space-y-0 rounded-2xl bg-white pt-10 pb-20 relative">
      <div
        className="flex flex-col rounded-xl bg-[#052035] text-white py-10 px-5 md:px-4 lg:px-20"
        style={{ marginTop: -20, marginBottom: -20 }}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 text-white items-center mb-20">
          <div className="pb-10 lg:pb-0 px-0 md:px-10 lg:px-0">
            <h1 className="text-center text-3xl lg:text-4xl mb-3">Our Goal</h1>
            <p className="text-center text-sm lg:text-base">
              By joining our Patron Program, individuals and brands can
              contribute to creating meaningful rewards and opportunities that
              inspire the next generation of creators and innovators. Our
              immediate goal is to raise ₦10 million to fund our pilot rewards
              program and platform improvements.
            </p>
          </div>

          <div className="flex justify-center items-center">
            <img
              src={Explore}
              className="w-[100%] md:w-[400px] lg:w-[700px] h-[200px] lg:h-[350px] object-contain"
            />
          </div>
        </div>

        <h1 className="text-center text-3xl lg:text-4xl mb-3">Benefits</h1>
        <p className="text-center pb-10 text-sm lg:text-base">
          As a patron, you will receive the following benefits
          <br />
          according to your level of contribution:
        </p>

        <img
          src={Table}
          className="self-center w-full md:w-[586px] lg:w-[648px] h-[174px] md:h-[283px] lg:h-[300px]"
        />
      </div>
    </section>
  );
};

export default Goal;
